<my-video-playlist-miniature *ngIf="playlist" [playlist]="playlist">
</my-video-playlist-miniature>
